import React from 'react'

import type { BaseChartProps } from '../../types'
import { ChartFactory } from '../ChartFactory/ChartFactory'

export const BarChart = (props: BaseChartProps) => {
  return <ChartFactory chartType="bar" {...props} />
}
